/**
 * @requires ./frc.js
 */

frc.animations = {
	"init": function() {
		var self = frc.animations;

		// Messaging modules
		$("section.messaging").each(function() {
			$(this).on("ScrollioMatch", function(e, d) {
				self.messaging(true, $(d));
			}).on("ScrollioUnmatch", function(e, d) {
				self.messaging(false, $(d));
			}).Scrollio({
		        action: 'toggleClass',
		        class: 'in-view',
		        trigger: {
		            multiplier: .999
		        }
			});
		});

		// Find Location module
		$("section.geo-search-combo").on("ScrollioMatch", function(e, d) {
			self.locationSearch(true, $(d));
		}).on("ScrollioUnmatch", function(e, d) {
			self.locationSearch(false, $(d));
		}).Scrollio({
			action: 'toggleClass',
			class: 'in-view',
			trigger: {
				multiplier: .999
			}
		});

		// Instagram module
		$("section.instagram").on("ScrollioMatch", function(e, d) {
			self.instagram($(d));
		}).Scrollio({
			action: 'setClass',
			class: 'in-view',
			trigger: {
				multiplier: .999
			}
		});

		// Listing module (Locations landing / Menus landing)
		$(window).on("listing-loaded", function() {
			$(".listing").each(function() {
				$(this).on("ScrollioMatch", function(e, d) {
					self.listing($(d));
				}).Scrollio({
					action: 'setClass',
					class: 'in-view',
					trigger: {
						multiplier: .999
					}
				});
			});
		});

		// Map (Location single page)
		$("section.locations-map").on("ScrollioMatch", function(e, d) {
			self.locationMap(true, $(d));
		}).on("ScrollioUnmatch", function(e, d) {
			self.locationMap(false, $(d));
		}).Scrollio({
			action: 'toggleClass',
			class: 'in-view',
			trigger: {
				multiplier: .999
			}
		});

		// Picture Bar (Location single page / Careers landing page)
		$(".picture-bar").on("ScrollioMatch", function(e, d) {
			self.pictureBar(true, $(d));
		}).on("ScrollioUnmatch", function(e, d) {
			self.pictureBar(false, $(d));
		}).Scrollio({
			action: 'toggleClass',
			class: 'in-view',
			trigger: {
				multiplier: .999
			}
		});

		// Menu (single)
		$(".menu-section").each(function() {
			$(this).on("ScrollioMatch", function(e, d) {
				self.menu(true, $(d));
			}).on("ScrollioUnmatch", function(e, d) {
				self.menu(false, $(d));
			}).Scrollio({
				action: 'toggleClass',
				class: 'in-view',
				trigger: {
					multiplier: .95
				}
			});
		});

		// Callout ("Benefits" section of Careers page)
		$(".callout").on("ScrollioMatch", function(e, d) {
			self.callout(true, $(d));
		}).on("ScrollioUnmatch", function(e, d) {
			self.callout(false, $(d));
		}).Scrollio({
			action: 'toggleClass',
			class: 'in-view',
			trigger: {
				multiplier: .999
			}
		});

		// Tiles (Careers landing page)
		$(".tiles").on("ScrollioMatch", function(e, d) {
			self.tiles($(d));
		}).Scrollio({
			action: 'setClass',
			class: 'in-view',
			trigger: {
				multiplier: .999
			}
		});

		// Careers Search Results
		$(".careers-module").on("careers-page-loaded", function(e, d) {
			$(".careers-search.page.active .careers-search-results-wrapper .career").each(function() {
				$(this).on("ScrollioMatch", function(e, d) {
					self.careers($(d));
				}).Scrollio({
					action: 'setClass',
					class: 'in-view',
					trigger: {
						multiplier: .999
					}
				});
			});
		});

		// Forms (ebites / contact) - Each form triggers a separate event so you can break this out into two different animations if you'd like

		$(window).on("ebites-form-loaded contact-form-loaded", function(e, d) {
			self.forms($(d));
		});
	},

	"reservations": function($targetElement) {
		// console.log('Reservations form on header is ready.');
		$targetElement.addClass('active');
	},

	"reservationsModal": function(boolOpen, $targetElement) {
		if (boolOpen) {
			// console.log('Reservations modal has been opened.');
		}
		else {
			// console.log('Reservations modal has been closed.');
		}
	},

	"groupDiningModal": function(boolOpen, $targetElement) {
		if (boolOpen) {
			// console.log('Group Dining modal has been opened.');
		}
		else {
			// console.log('Group Dining modal has been closed.');
		}
	},

	"messaging": function(boolMatch, $targetElement) {
		if (boolMatch) {
			// console.log('Scrollio match: Messaging');
		}
		else {
			// console.log('Scrollio unmatch: Messaging');
		}
	},

	"locationSearch": function(boolMatch, $targetElement) {
		if (boolMatch) {
			// console.log('Scrollio match: Location Search');
		}
		else {
			// console.log('Scrollio unmatch: Location Search');
		}
	},

	"instagram": function($targetElement) {
		// console.log('Scrollio match: Instagram');
	},

	"listing": function($targetElement) {
		$listingState = $targetElement.closest('.listing-block');
		// console.log('Scrollio match: Listing');
	},

	"locationMap": function(boolMatch, $targetElement) {
		// console.log('Scrollio match: Location Map');
	},

	"pictureBar": function(boolMatch, $targetElement) {
		if (boolMatch) {
			if ($targetElement.hasClass('trio')) { // Careers landing
				// console.log('Scrollio match: Picture Bar (Trio)');
			}
			else {
				// console.log('Scrollio match: Picture Bar');
			}
		}
		else {
			if ($targetElement.hasClass('trio')) {
				// console.log('Scrollio unmatch: Picture Bar (Trio)');
			}
			else {
				// console.log('Scrollio unmatch: Picture Bar');
			}
		}
	},

	"menu": function(boolMatch, $targetElement) {
		if (boolMatch) {
			// console.log('Scrollio match: Menu Section');
		}
		else {
			// console.log('Scrollio unmatch: Menu Section');
		}
	},

	"callout": function(boolMatch, $targetElement) {
		if (boolMatch) {
			// console.log('Scrollio match: Callout');
		}
		else {
			// console.log('Scrollio unmatch: Callout');
		}
	},

	"tiles": function($targetElement) {
		// console.log('Scrollio match: Tiles');
	},

	"careers": function($targetElement) {
		// console.log('Scrollio match: Careers listing');
	},

	"forms": function($targetElement) {
		// console.log('Form is ready.');
		$targetElement.addClass('in-view');
	}
};
